import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h5",
  style: {"padding":"30px"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { style: {"flex-wrap":"wrap","display":"flex","align-items":"center"} }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "row",
  style: {"margin-bottom":"0.25rem"}
}
const _hoisted_7 = {
  class: "col-12",
  style: {"margin-bottom":"0.5rem","padding-top":"1rem","padding-bottom":"0.25rem"}
}
const _hoisted_8 = {
  class: "h4",
  style: {"padding":"4px 10px"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  style: {"padding":"0 15px"}
}
const _hoisted_13 = { style: {"word-break":"break-word","word-wrap":"break-word"} }
const _hoisted_14 = { style: {"width":"90vw","margin-left":"auto","margin-right":"auto"} }
const _hoisted_15 = {
  class: "tabs",
  style: {"margin-top":"1rem","margin-bottom":"1rem"}
}
const _hoisted_16 = { class: "nav nav-tabs nav-fill" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "tab-content" }
const _hoisted_21 = {
  class: "navColor",
  style: {"padding-top":"1rem","padding-bottom":"3rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileBackgroundImage = _resolveComponent("ProfileBackgroundImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Comments = _resolveComponent("Comments")!
  const _component_LazyShow = _resolveComponent("LazyShow")!
  const _component_PublicBadge = _resolveComponent("PublicBadge")!
  const _component_PublicProject = _resolveComponent("PublicProject")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createBlock(_component_Loading, {
    ref: "loading",
    minHeight: "40vh"
  }, {
    default: _withCtx(() => [
      (_ctx.isUserNotFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "ユーザーが見つかりませんでした。"))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ProfileBackgroundImage, { src: _ctx.backgroundSrc }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "avatarImage img-thumbnail",
                    style: {"border-radius":"50%"},
                    alt: "avatar",
                    src: _ctx.urls.getUserImageSrc(_ctx.userProfile.user)
                  }, null, 8, _hoisted_5)
                ]),
                (_ctx.isPageOwner)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      style: {"padding":"0.375rem 1rem","font-size":"0.95rem","margin-left":"auto","margin-top":"auto","margin-bottom":"0.3rem"},
                      to: "/account/"
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" 編集画面へ ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.userProfile.user.displayName), 1)
                  ]),
                  (_ctx.userProfile.profile.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", {
                          class: "properties_title",
                          style: {"display":"inline-block"}
                        }, [
                          _createElementVNode("small", { style: {"color":"#6c757d"} }, "地域 : ")
                        ], -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.userProfile.profile.location), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formatDate(_ctx.userProfile.profile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", {
                          class: "properties_title",
                          style: {"display":"inline-block"}
                        }, [
                          _createElementVNode("small", { style: {"color":"#6c757d"} }, "誕生日 : ")
                        ], -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.userProfile.profile)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.userProfile.profile.website)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", {
                          class: "properties_title",
                          style: {"display":"inline-block"}
                        }, [
                          _createElementVNode("small", { style: {"color":"#6c757d"} }, "website : ")
                        ], -1)),
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLinkClick && _ctx.onLinkClick(...args))),
                          style: {"text-decoration":"underline","cursor":"pointer"}
                        }, _toDisplayString(_ctx.userProfile.profile.website), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.userProfile.profile.selfIntroduction)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.userProfile.profile.selfIntroduction), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", _hoisted_17, [
                    _createVNode(_component_router_link, {
                      to: '/' + _ctx.userProfile.user.userName + '?tab=comments',
                      class: _normalizeClass(["nav-link", _ctx.getActiveClass('comments')]),
                      tabindex: _ctx.getTabIndex('comments')
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" コメント ")
                      ])),
                      _: 1
                    }, 8, ["to", "class", "tabindex"])
                  ]),
                  _createElementVNode("li", _hoisted_18, [
                    _createVNode(_component_router_link, {
                      to: '/' + _ctx.userProfile.user.userName + '?tab=badge',
                      class: _normalizeClass(["nav-link", _ctx.getActiveClass('badge')]),
                      tabindex: _ctx.getTabIndex('badge')
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" バッジ ")
                      ])),
                      _: 1
                    }, 8, ["to", "class", "tabindex"])
                  ]),
                  _createElementVNode("li", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: '/' + _ctx.userProfile.user.userName + '?tab=public-page',
                      class: _normalizeClass(["nav-link", _ctx.getActiveClass('public-page')]),
                      tabindex: _ctx.getTabIndex('public-page')
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" 公開ページ ")
                      ])),
                      _: 1
                    }, 8, ["to", "class", "tabindex"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_LazyShow, {
                      show: _ctx.getActiveClass('comments')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Comments, {
                          user: _ctx.userProfile.user
                        }, null, 8, ["user"])
                      ]),
                      _: 1
                    }, 8, ["show"]),
                    _createVNode(_component_LazyShow, {
                      show: _ctx.getActiveClass('badge')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PublicBadge, { userName: _ctx.userName }, null, 8, ["userName"])
                      ]),
                      _: 1
                    }, 8, ["show"]),
                    _createVNode(_component_LazyShow, {
                      show: _ctx.getActiveClass('public-page')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PublicProject, {
                          list: _ctx.userProfile.publicPageList
                        }, null, 8, ["list"])
                      ]),
                      _: 1
                    }, 8, ["show"])
                  ])
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }, 512))
}